import moon  from './assets/moon';
import planning from './assets/planing';
import lorry from './assets/lorry';
import hamburger from './assets/hamburger';
import drop from './assets/drop';
import strawberry from './assets/strawberry';
import cool from './assets/cool';
import euro from './assets/euro';
import check from './assets/check';
import logo from './assets/logo';
import nagel_logo from './assets/nagel-logo';
import nagel_text_icon_light from './assets/nagel-group-text_light';
import nagel_text_icon_dark from './assets/nagel-group-text_dark';
import date from './assets/date';
import time from './assets/time';
import location from './assets/location';
import plus from './assets/plus';
import snowflake from './assets/snowflake';
import leaf from './assets/leaf';
import sun from './assets/sun';
import notifications from './assets/notifications';
import warehouse from './assets/warehouse';
import downward_arrow from './assets/downward_arrow';
import hollow_pin from './assets/hollow_pin';
import trans_eu from './assets/trans_eu';
import timocom from './assets/timocom';
import filter from './assets/filter';
import apple from './assets/apple';
import air_conditioner from './assets/air_conditioner';
import citrus from './assets/citrus';
import delete_icon from './assets/delete_icon';
import share_icon from './assets/share_icon';
import pen_line from './assets/pen_line';
import repost from './assets/repost';
import check_mark from './assets/check_mark';
import arrow_alt_circle_up from './assets/arrow_alt_circle_up';
import arrow_alt_circle_down from './assets/arrow_alt_circle_down';
import arrow_up_down from './assets/arrow_up_down';
import in_progress from './assets/in_progress';
import weight from './assets/weight';
import departure_calendar from './assets/departure_calendar';
import arrival_calendar from './assets/arrival_calendar';
import person from './assets/person';
import clock from './assets/clock';
import parking from './assets/parking';
import contextual_menu_dots from './assets/contextual_menu_dots';
import date_range from './assets/date_range';
import triangle_exclamation from './assets/triangle-exclamation';
import circle_info from './assets/circle-info';
import trash from './assets/trash';
import light_create_lot from './assets/light_create_lot';
import light_create_transport_orders from './assets/light_create_transport_orders';
import dark_create_lot from './assets/dark_create_lot';
import dark_create_transport_orders from './assets/dark_create_transport_orders';
import search from './assets/search';
import shelves from './assets/shelves';
import x_icon from './assets/x_icon';
import arrow_left from './assets/arrow_left';
import arrow_right from './assets/arrow_right';
import meeting_point from './assets/meeting_point';
import border from './assets/border';
import customs_processing from './assets/customs_processing';
import ferry from './assets/ferry';
import tunnel from './assets/tunnel';
import circle_arrow_down from './assets/circle_arrow_down';
import circle_arrow_up from './assets/circle_arrow_up';
import magic_want from './assets/magic_wand';
import arrows_rotate from './assets/arrows_rotate';
import arrow_rotate_left from './assets/arrow_rotate_left';
import truck_sections from './assets/truck_sections';
import arrow_down_icon from './assets/arrow_down';
import flag_icon from './assets/flag_icon';
import finish_flag from './assets/finish_flag';
import distance from './assets/distance';
import speed_meter from './assets/speed_meter';
import envelope from './assets/envelope';
import boxes from './assets/boxes';
import key from './assets/key';
import drag_grid from './assets/drag_grid';
import lock from './assets/lock';
import warning from './assets/warning';
import edit from './assets/edit';
import circle_check_mark from './assets/circle_check_mark';
import pinned_icon from './assets/pinned_icon';

export const icons = [
    { name: 'planning_icon', svg: planning },
    { name: 'lorry_icon', svg: lorry },
    { name: 'hamburger_icon', svg: hamburger },
    { name: 'drop_icon', svg: drop },
    { name: 'strawberry_icon', svg: strawberry },
    { name: 'cool_icon', svg: cool },
    { name: 'euro_icon', svg: euro },
    { name: 'check_icon', svg: check },
    { name: 'logo', svg: logo },
    { name: 'nagel_logo', svg: nagel_logo },
    { name: 'nagel_text_icon_light', svg: nagel_text_icon_light },
    { name: 'nagel_text_icon_dark', svg: nagel_text_icon_dark },
    { name: 'date_icon', svg: date },
    { name: 'time_icon', svg: time },
    { name: 'location_icon', svg: location },
    { name: 'plus_icon', svg: plus },
    { name: 'snowflake_icon', svg: snowflake },
    { name: 'leaf_icon', svg: leaf },
    { name: 'moon_icon', svg: moon },
    { name: 'sun_icon', svg: sun },
    { name: 'notification_icon', svg: notifications },
    { name: 'warehouse_icon', svg: warehouse },
    { name: 'downward_arrow_icon', svg: downward_arrow },
    { name: 'hollow_pin_icon', svg: hollow_pin },
    { name: 'trans_eu_icon', svg: trans_eu },
    { name: 'timocom_icon', svg: timocom },
    { name: 'filter_icon', svg: filter },
    { name: 'apple_icon', svg: apple },
    { name: 'air_conditioner_icon', svg: air_conditioner },
    { name: 'citrus_icon', svg: citrus },
    { name: 'delete_icon', svg: delete_icon },
    { name: 'share_icon', svg: share_icon },
    { name: 'pen_line_icon', svg: pen_line },
    { name: 'repost_icon', svg: repost },
    { name: 'check_mark_icon', svg: check_mark },
    { name: 'circle_check_mark_icon', svg: circle_check_mark },
    { name: 'arrow_alt_circle_up_icon', svg: arrow_alt_circle_up },
    { name: 'arrow_alt_circle_down_icon', svg: arrow_alt_circle_down },
    { name: 'arrow_up_down_icon', svg: arrow_up_down },
    { name: 'in_progress_icon', svg: in_progress },
    { name: 'weight_icon', svg: weight },
    { name: 'departure_calendar_icon', svg: departure_calendar },
    { name: 'arrival_calendar_icon', svg: arrival_calendar },
    { name: 'person_icon', svg: person },
    { name: 'clock_icon', svg: clock },
    { name: 'parking_icon', svg: parking },
    { name: 'contextual_menu_dots_icon', svg: contextual_menu_dots },
    { name: 'date_range_icon', svg: date_range },
    { name: 'triangle-exclamation_icon', svg: triangle_exclamation },
    { name: 'circle_info_icon', svg: circle_info },
    { name: 'arrow_down_icon', svg: arrow_down_icon },
    { name: 'trash_icon', svg: trash },
    { name: 'light_create_lot', svg: light_create_lot },
    { name: 'light_create_transport_orders', svg: light_create_transport_orders },
    { name: 'dark_create_lot', svg: dark_create_lot },
    { name: 'dark_create_transport_orders', svg: dark_create_transport_orders },
    { name: 'search_icon', svg: search },
    { name: 'shelves', svg: shelves},
    { name: 'x_icon', svg: x_icon },
    { name: 'arrow_left', svg: arrow_left },
    { name: 'arrow_right', svg: arrow_right },
    { name: 'meeting_point', svg: meeting_point },
    { name: 'border', svg: border },
    { name: 'customs_processing', svg: customs_processing},
    { name: 'ferry', svg: ferry },
    { name: 'tunnel', svg: tunnel },
    { name: 'circle_arrow_down', svg: circle_arrow_down },
    { name: 'circle_arrow_up', svg: circle_arrow_up },
    { name: 'magic_wand_icon', svg: magic_want },
    { name: 'arrows_rotate_icon', svg: arrows_rotate },
    { name: 'truck_sections_icon', svg: truck_sections},
    { name: 'flag_icon', svg: flag_icon },
    { name: 'finish_flag', svg: finish_flag },
    { name: 'distance_icon', svg: distance},
    { name: 'speed_meter_icon', svg: speed_meter},
    { name: 'envelope_icon', svg: envelope },
    { name: 'boxes_icon', svg: boxes},
    { name: 'key_icon', svg: key },
    { name: 'drag_grid_icon', svg: drag_grid },
    { name: 'lock_icon', svg: lock },
    { name: 'arrow_rotate_left_icon', svg: arrow_rotate_left },
    { name: 'warning_icon', svg: warning },
    { name: 'edit_icon', svg: edit },
    { name: 'pinned_icon', svg: pinned_icon}];